import { render, staticRenderFns } from "./AreaItem.vue?vue&type=template&id=52491696&scoped=true"
import script from "./AreaItem.vue?vue&type=script&lang=js"
export * from "./AreaItem.vue?vue&type=script&lang=js"
import style0 from "./AreaItem.vue?vue&type=style&index=0&id=52491696&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52491696",
  null
  
)

export default component.exports